import { updateGenericSetting } from '../../Services/admin/adminGenericSettings';
import { GenericSetting } from '../../Types/portal';
import { useBizMutation } from '../useBizQuery';
import { QUERYKEY_GENERICSETTINGS } from '../useGenericSetting';

export const useSaveGenericSetting = () => {
	const wrapperFn = (params: { setting: GenericSetting }) => {
		return updateGenericSetting(params.setting);
	};
	const { mutate, statusState } = useBizMutation(wrapperFn, {
		getQueryKeyForInvalidation: () => [[QUERYKEY_GENERICSETTINGS]],
	});

	return {
		saveSetting: (setting: GenericSetting) => mutate({ setting }),
		statusState,
	};
};
